<template>
    <div class="row" v-if="bloqueo">
    <div  class="col-md-11">
         <div  class="alert alert-warning" role="alert">                
                <h4>Para modificar los datos de la empresa, contacte con el equipo de Soporte</h4>
            </div>
    </div></div>
    <div v-if="id>0" class="row">
        <div class="col-md-6">
            <empresa-datos-datos :empresa="empresa" :verifactu="verifactu" :bloqueo="bloqueo" :id="id" />
        </div>
        <div class="col-md-5">
            <Empresa-datos-contabilidad :empresa="empresa" :verifactu="verifactu" :bloqueo="bloqueo" :id="id" />
            <Empresa-datos-facturacion :empresa="empresa" :verifactu="verifactu" :bloqueo="bloqueo" :id="id" />
        </div>
    </div>
    <div v-else class="row">
        <div class="col-md-6">
            <empresa-datos-datos :empresa="empresa" :verifactu="verifactu" :bloqueo="bloqueo" :id="id" />
        </div>
    </div>
</template>
<script>
import EmpresaDatosDatos from './EmpresaDatosDatos.vue'
import EmpresaDatosContabilidad from './EmpresaDatosContabilidad.vue'
import EmpresaDatosFacturacion from './EmpresaDatosFacturacion.vue'
import { PwgsApi } from '../../../../services/PwgsApi';

export default {
    props: ['empresa', 'id'],
    components: {
        'empresa-datos-datos': EmpresaDatosDatos,
        'Empresa-datos-contabilidad': EmpresaDatosContabilidad,
        'Empresa-datos-facturacion':EmpresaDatosFacturacion,
    },
    data() {
        return {
            verifactu: '',
            bloqueo:'',
        }
    },
    methods: {
        async comprobarVerifactu(){
            const api = new PwgsApi();
            let aux = await api.get('sistema-facturacion/verifactu');
            if (aux.sistema_facturacion == 1) {
                this.verifactu = true;
            }
            else {
                this.verifactu = false;
            }
        },
        async comprobarPermisoBloqueo(){
            try{
                const api = new PwgsApi();
                const auxusuario = localStorage.getItem('usuario');
                const resppermisos = await api.get('usuarios/'+auxusuario+'/permisos');
                const permisos = resppermisos.datos || [];
                // unicamente soporte puede editar estos campos
                this.bloqueo = !permisos.some(p => p.nombre_permiso === 'soporte');
            }catch(error){
                this.bloqueo = true;
            }
        },  
    },
      mounted() {
        this.comprobarVerifactu();
        this.comprobarPermisoBloqueo();
    },
}
</script>